<template>
  <header class="">
    <div class="desktop-header-wrapper">
      <router-link
        :to="{ path: '/#promo' }"
        v-scroll-to="'#promo'"
        class="logo no-border"
      >
        <img src="@/assets/logo.png" alt="Бочкарёв логотип" class="" />
      </router-link>

      <div class="d-flex align-items-center justify-content-center h-100">
        <router-link
          :to="{ path: '/#promo' }"
          v-scroll-to="'#promo'"
          class="header-link"
          >Главная</router-link
        >

        <router-link
          :to="{ path: '/#mechanics' }"
          class="header-link"
          v-scroll-to="'#mechanics'"
          >Механика</router-link
        >

        <router-link
          :to="{ path: '/#prizes' }"
          class="header-link"
          v-scroll-to="'#prizes'"
          >Призы</router-link
        >

        <router-link
          :to="{ path: '/#winners' }"
          v-scroll-to="'#winners'"
          class="header-link"
          >Победители</router-link
        >
      </div>

      <div class="d-flex align-item-center">
        <b-button
          class="header-button button button-green"
          v-if="user"
          @click="openCodeModal"
          variant="primary"
          >Введите код</b-button
        >

        <b-button
          class="header-button button button-green"
          v-if="!user"
          v-b-modal.login-modal
          variant="primary"
          >Введите код</b-button
        >

        <b-button
          class="header-button button button-office"
          v-b-modal.login-modal
          variant="primary"
          v-if="!user && $route.path != '/office'"
        >
          <img src="@/assets/svg/user.svg" />
        </b-button>

        <b-button
          class="header-button button button-office"
          variant="primary"
          to="/office"
          v-if="user && $route.path != '/office'"
        >
          <img src="@/assets/svg/user.svg" />
        </b-button>

        <b-button
          class="header-button button button-office"
          variant="primary"
          @click="logout"
          v-if="user && $route.path == '/office'"
        >
          <img src="@/assets/svg/exit.svg" />
        </b-button>

        <div class="mobile-icon" @click="mobileMenuOpened = !mobileMenuOpened">
          <img src="@/assets/svg/menu.svg" v-if="!mobileMenuOpened" />

          <img src="@/assets/svg/close.svg" v-if="mobileMenuOpened" />
        </div>
      </div>
    </div>

    <div class="mobile-menu" :class="{ active: mobileMenuOpened }">
      <router-link
        :to="{ path: '/#promo' }"
        v-scroll-to="'#promo'"
        class="header-link"
        @click.native="mobileMenuOpened = false"
        >Главная</router-link
      >

      <router-link
        class="header-link"
        :to="{ path: '/#mechanics' }"
        v-scroll-to="'#mechanics'"
        @click.native="mobileMenuOpened = false"
        >Механика</router-link
      >

      <router-link
        v-scroll-to="'#prizes'"
        :to="{ path: '/#prizes' }"
        class="header-link"
        @click.native="mobileMenuOpened = false"
        >Призы</router-link
      >

      <router-link
        :to="{ path: '/#winners' }"
        v-scroll-to="'#winners'"
        class="header-link"
        @click.native="mobileMenuOpened = false"
        >Победители</router-link
      >

      <b-button
        class="mobile-button button button-green"
        v-if="user"
        @click="openCodeModal"
        variant="primary"
        >Введите код</b-button
      >

      <b-button
        class="mobile-button button button-green"
        v-if="!user"
        v-b-modal.login-modal
        variant="primary"
        >Введите код</b-button
      >

      <!-- <b-button class="mobile-button button button-office"
                v-b-modal.login-modal
                v-if="!user"
                @click="mobileMenuOpened = false"
                variant="primary">
        <img src="@/assets/svg/user.svg" />
      </b-button> -->

      <!-- <router-link to="office"
                   class="login-button"
                   v-if="user"
                   @click.native="mobileMenuOpened = false">
        <img src="@/assets/svg/user.svg" />
      </router-link> -->
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"

export default {
  name: "HeaderRegion",

  data: () => ({
    mobileMenuOpened: false,
    rules: "",
  }),

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  mounted(){
  },

  methods: {
    ...mapMutations({
      saveUser: 'saveUser',
      saveToken: 'saveToken'
    }),

    openCodeModal() {
      this.$bvModal.show('promo-end-modal')
      // this.$bvModal.show('enter-code-modal')
    },

    openModal() {
      // this.$bvModal.show('plug-modal')

      // if(this.user){
      //   this.$bvModal.show('cash-voucher-modal')
      // } else {
      //   this.$bvModal.show('enter-modal')
      // }

      this.mobileMenuOpened = false;
    },

    logout() {
      this.saveUser(null)
      this.saveToken(null)
      this.$router.push('/')

      localStorage.removeItem('token-bockarev')
    }
  },
};
</script>

<style scoped lang="scss">
.desktop-header-wrapper {
  width: 100%;
  background-color: $white;
  display: flex;
  align-items: center;
  font-family: $regular !important;
  padding: 0 20px;
  position: relative;
  max-width: 1128px;
  border-radius: 70px;
  height: 81px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);

  @media (max-width: 1260px) {
    padding: 0 15px;
    height: 68px;
    max-width: 879px;
  }

  @media (max-width: 999px) {
    padding: 0 30px;
    margin-top: 28px;
    max-width: 633px;
  }

  @media (max-width: 576px) {
    height: 63px;
    max-width: 97%;
    background-color: transparent;
    box-shadow: none;
    margin-top: 36px;
  }
}

.logo {
  height: 100%;
  position: relative;
  vertical-align: middle;
  display: flex;
  align-items: center;
  margin-right: 50px;
  margin-left: 40px;

  @media (max-width: 1260px) {
    margin-right: 25px;
    max-height: 55px;
    margin-left: 20px;
  }

  @media (max-width: 999px) {
    margin-left: 0;
  }

  img {
    max-height: 73px;

    @media (max-width: 1260px) {
      max-height: 50px;
    }

    @media (max-width: 999px) {
      max-height: 43px;
    }

    @media (max-width: 576px) {
      max-height: 63px;
    }
  }
}

.button-green {
  margin-right: 20px;
  height: 47px;
  font-family: $regular;
  font-weight: 500;
  font-size: 16px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: transparent;
  background-image: url("@/assets/button-light-green.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
  transition: 0.5s all;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 1260px) {
    margin-right: 10px;
  }

  @media (max-width: 999px) {
    margin-right: 14px;
  }

  @media (max-width: 576px) {
    margin-right: 0;
  }
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-link {
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  transition: 0.4s all ease;
  margin-right: 20px;
  padding-bottom: 10px;
  margin-top: 10px;
  font-weight: 500;
  border-bottom: 2px solid transparent;
  font-family: $sans !important;
  color: $grey;

  @media (max-width: 1260px) {
  }

  @media (max-width: 999px) {
    display: none;
  }

  &:hover {
    color: $green;
  }
}

.active-header-link {
}

.router-link-exact-active {
  color: $black;
  border-bottom: 2px solid $green;
  padding-bottom: 10px;

  @media (max-width: 999px) {
    border-bottom: 2px solid transparent;
    color: $green;
  }
}

.no-border {
  border-bottom: none !important;
  padding-bottom: 0 !important;
}

.mobile-icon {
  transition: 1s all;
  margin-left: 15px;
  cursor: pointer;
  width: 30px;
  display: none;
  margin-left: 15px;
  align-items: center;
  background-color: $green;
  transition: 0.5s all;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
  z-index: 1000;

  @media (max-width: 999px) {
    display: flex;
    height: 41px;
    width: 41px;
  }

  @media (max-width: 576px) {
    height: 46px;
    width: 46px;
  }

  &:hover {
    opacity: 0.9;
  }

  img {
    margin: 0;
    transition: 1s all;
    max-width: 23px;
  }
}

.mobile-menu {
  display: none;
  background-color: $white;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  position: absolute;
  width: 100vw;
  margin-left: -3000px;
  margin-top: 0;
  transition: 0.8s all ease;
  z-index: 999;
  padding: 0;
  padding-top: 23px;
  padding-bottom: 35px;

  @media (max-width: 999px) {
    display: flex;
  }

  .header-link {
    font-size: 16px;
    display: block !important;
    margin-top: 0px;
    margin-left: 0;
    margin-right: 0 !important;
    padding: 6px 20px;
    font-family: $sans !important;
    color: $grey;

    &:first-child {
      margin-top: 0;
    }
  }

  .login-button {
    font-size: 16px;
    display: block !important;
    margin-top: 0px;
    margin-left: 0;
    margin-right: 0 !important;
    padding: 15px 20px;
    background-color: $black;
    width: 100%;
    color: $white;
    text-align: left;
    height: 59px;
    transition: 0.4s all;

    &:hover {
      text-decoration: none;
      opacity: 0.85;
    }
  }

  &.active {
    margin-left: 0;
    margin-right: 0;
  }
}

.header-button {
  @media (max-width: 999px) {
    height: 41px;
  }

  @media (max-width: 576px) {
    display: none;
  }
}

.mobile-button {
  width: 100%;
  height: 46px;
  font-size: 16px !important;
  text-align: center;
  max-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  border-radius: 20px;
  transition: 0.5s all;
  display: none;

  @media (max-width: 576px) {
    display: flex;
  }

  &:hover {
    opacity: 0.8 !important;
  }
}

.button-office {
  background-color: $green;
  transition: 0.5s all;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  width: 46px;
  padding: 0 !important;

  &:hover {
    background-color: $green;
    opacity: 0.8;
  }

  @media (max-width: 999px) {
    height: 41px;
    width: 41px;
  }

  @media (max-width: 576px) {
    height: 46px;
    width: 46px;
  }
}

.black {
  color: $black !important;
}

.no-b {
  border-bottom: none !important;
  padding-bottom: 12px;
}

header {
  position: fixed;
  width: 100%;
  z-index: 1001;
  display: flex;
  justify-content: center;
  background-color: transparent;
}
</style>
